module.exports = __webpack_public_path__ + "assets/img/Logo-SDMX.525d6b31.png";